import React from 'react';
import { ClipboardDocumentListIcon } from '../../../automationStudioIcons';
import styles from '../../../../../styles/automationStudio/automationStudio.module.scss';
import { LABELS } from '../../../content';

export default function InstructionsEmptyState() {
    return (
        <div className={styles.emptyState}>
            <div className={styles.instructionsEmptyIcon} aria-hidden>
                <ClipboardDocumentListIcon className={styles.instructionsEmptyIconSvg} />
            </div>
            <p className={`${styles.asTypoBody2} ${styles.asTextSecondary}`}>
                {LABELS.NO_AI_STEPS_YET}
            </p>
            <div className={styles.instructionsEmptyHint}>
                <p className={`${styles.asTypoBody2} ${styles.asTextSecondary} ${styles.instructionsEmptyHintText}`}>
                    {LABELS.INSTRUCTIONS_EMPTY_HINT}
                </p>
            </div>
        </div>
    );
}
